import { requirementsPt } from '@/modules/requirements/i18n'

import { commonPt } from './pt'

const i18nDict = {
  pt: {
    common: commonPt,
    modules: {
      requirements: requirementsPt
    }
  }
}

export function i18n(): typeof i18nDict.pt {
  const currentLanguage = 'pt'

  return i18nDict[currentLanguage]
}
